/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import * as React from 'react';

import {
  ButtonProps,
  Popover,
} from '@mui/material';
import ColorPicker from '../../../../ui/ColorPicker';
import { StyledButton } from '../../styles';

interface ColorPickerButtonProps extends Omit<Omit<ButtonProps, 'color'>, 'onChange'> {
  color: string;

  onChange?: (color: string) => void;
}

export default function ColorPickerButton(props: ColorPickerButtonProps) {
  const {
    color, onChange, ...rest
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  return (
    <>
      <StyledButton
        {...rest}
        onClick={(e) => {
          setAnchorEl(anchorEl ? null : e.currentTarget);
        }}
      />
      <Popover open={!!anchorEl} anchorEl={anchorEl} onClose={() => { setAnchorEl(null); }}>
        <ColorPicker
          color={color}
          onChange={
            (v) => {
              onChange?.(v);
            }
          }
        />
      </Popover>
    </>
  );
}
